import { usePostMutation } from "@/api/swr/useMutation";
import { assessmentDateSchema } from "@/schema/console/companies/AssessmentDate";
import { z } from "zod";

type Config = Parameters<
  typeof usePostMutation<typeof assessmentDateSchema, z.ZodNull>
>[3];

export function useUpdateAssessmentDate(id: number, config: Config) {
  return usePostMutation(
    assessmentDateSchema,
    z.null(),
    `/console/companies/${id}/update_assessment_date`,
    config,
  );
}
